import * as methods from './mixin_methods'
import * as common from '../common/common.js'
export default {
    methods:{
        ...methods,
        ...common
    }  
}